export interface AddressType {
  id: number;
  street?: string;
  number?: string;
  box?: string;
  zip?: string;
  municipality?: string;
  email?: string;
  fixedNumber?: string;
  country?: string;
  cellPhoneNumber?: string;
}

export class Address implements AddressType {
  id: number;
  street?: string;
  number?: string;
  box?: string;
  zip?: string;
  municipality?: string;
  email?: string;
  fixedNumber?: string;
  country?: string;
  cellPhoneNumber?: string;

  constructor(data?: AddressType) {
    this.id = -1;
    data && Object.assign(this, data);
  }
}
